// components/Carousel.js

import React, { useEffect, useState } from "react";
import './Carousel.css';
import ani2 from '../../assets/ani2.jpg'
import clothe1 from '../../assets/clothe1.jpg'
import crop2 from '../../assets/crop2.jpg'
import shoe2 from '../../assets/shoe2.jpg'
import water1 from '../../assets/water1.jpg'
import wood1 from '../../assets/wood1.jpg'

const images = [
    { id: 1, image:  wood1},
    { id: 2, image: clothe1 },
    { id: 3, image: shoe2},
    { id: 4, image: crop2},
    { id: 5, image: ani2},
    { id: 6, image: water1}
];

function Carousel() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((currentImageIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentImageIndex]);

  return (
    <div className="carousel">
      <img src={images[currentImageIndex].image} alt="carousel" />
    </div>
  );
}

export default Carousel;
